import React, { forwardRef } from 'react';
import cn from 'classnames';

import classes from './base-button.module.scss';
import { variants, sizes, variantDisabledClasses, iconSizeClasses, type Variant, type Size } from './variants';

export type BaseButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
  endIcon?: React.ReactNode;
  icon?: boolean;
  size?: Size;
  startIcon?: React.ReactNode;
  variant?: Variant;
};

const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(function BaseButton(props, ref) {
  const {
    active,
    children,
    className,
    disabled,
    endIcon,
    icon = false,
    size = 'medium',
    startIcon,
    tabIndex = 0,
    variant = 'primary',
    ...restProps
  } = props;

  return (
    <button
      ref={ref}
      className={cn(
        classes.button,
        variants[variant],
        sizes[size],
        {
          [classes.icon]: icon,
          [iconSizeClasses[size]]: icon,
          [classes.active]: active,
          [classes.disabled]: disabled,
          [variantDisabledClasses[variant]]: disabled
        },
        className
      )}
      disabled={disabled}
      tabIndex={disabled ? -1 : tabIndex}
      {...restProps}
    >
      {startIcon && <span className={classes.startIcon}>{startIcon}</span>}
      {children}
      {endIcon && <span className={classes.endIcon}>{endIcon}</span>}
    </button>
  );
});

export default BaseButton;
